<div
    class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-min-w-768px"
>
    <div class="modal-header">
        <div
            class="modal-title h4"
            role="heading"
            aria-level="1"
        >
            <span>{{
                _i18n._9543_OTHER_COMMITMENTS_WITH_THIS_GOAL | translate
            }}</span>
        </div>
        <button
            type="button"
            class="close"
            (click)="_dialogRef.close()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <div class="cmps-cdk-pb-1 shared-goals-title">
            <span
                >{{ _i18n._9541_GOAL_KPI_ | translate }}
                {{ _data.selectedGoalId.metricName }}</span
            >
            <div>
                <span class="text-muted">{{
                    _i18n._9542_GOAL_ | translate
                }}</span
                >&nbsp;<span class="text-orange">{{
                    _data.selectedGoalId.goal
                }}</span>
            </div>
        </div>

        <ul class="list-group shared-goals-container">
            <li
                class="list-group-item shared-goal-list"
                *ngFor="let goal of _data.goalsActives"
            >
                <div class="row">
                    <div class="col-12 shared-goal-behaviour">
                        <span
                            >{{ _i18n._9525_B_ | translate }}
                            {{ goal.behaviourName }}</span
                        >
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 shared-goal-sub-behaviour">
                        <span
                            >{{ _i18n._9526_S_B_ | translate }}
                            {{ goal.subBehaviourName }}</span
                        >
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <div class="status-text d-flex align-items-center">
                            <span class="text-muted">{{
                                _i18n._9420_STATUS_ | translate
                            }}</span
                            >&nbsp;
                            <span
                                [class.text-muted]="
                                    goal.statusId === _GoalStatus.CLOSED
                                "
                                [class.text-orange]="
                                    goal.statusId ===
                                        _GoalStatus.PRE_APPROVAL ||
                                    goal.statusId === _GoalStatus.UPDATING
                                "
                                [class.text-active]="
                                    goal.statusId === _GoalStatus.ACTIVE
                                "
                                [class.text-danger]="
                                    goal.statusId ===
                                        _GoalStatus.PENDING_CLOSE ||
                                    goal.statusId === _GoalStatus.DRAFT
                                "
                            >
                                {{
                                    _goalStatusTranslationMap[goal.statusId]
                                        | translate
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="status-text d-flex align-items-center">
                            <span class="text-muted">{{
                                _i18n._9544_GOALS_ | translate
                            }}</span
                            >&nbsp;
                            <span class="shared-goal-metrics-name">{{
                                goal.metricName
                            }}</span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>
